var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ak-model-count-group',{attrs:{"options":_vm.options}}),_c('ak-model-chart',{staticClass:"m-t-24",attrs:{"title":"销售趋势","options":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }